// extracted by mini-css-extract-plugin
export default {"loading":"JnepxXH3uI84r2YBFAKU"};